<template>
  <div v-if="menu">
    <ThemedComponent
      path="Page"
      :component-name="`Detail${menu.componentName}`"
    />
  </div>
</template>

<script setup lang="ts">
import { LANGUAGES } from '~/constants/language'

definePageMeta({
  alias: LANGUAGES.map(lang => `/${lang}/:slug/:slugDetail`),
})

const { menu } = await useResolvedMenuRoute()
</script>
